import Smile2 from '@assets/icons/smile-2.svg'
import { Icon } from './Icon'

export const Smile2Icon = Icon(Smile2)
